import { Card } from '../../../../../components/atoms';
import { Table } from '../../../../../components/organisms/Table/Table';
import TableStatus from '../../../../../components/templates/TableStatus/TableStatus';
import { tableStatusProps } from '../../../../../components/templates/TableStatus/utils';
import { monthlyTableComponents } from './molecules';
import { MonthlyReportsFilter } from './style';

export const MonthlyReportsLayout = ({
  headers,
  data,
  grid,
  handleAction,
  yearsFilter,
  isLoading,
  isError,
  error,
}) => {
  return (
    <Card
      title="Monthly reports"
      icon={<MonthlyReportsFilter filters={[yearsFilter]} />}
      className="monthly-reports"
    >
      {
        <TableStatus
          isLoading={isLoading}
          isError={isError}
          error={error}
          {...tableStatusProps}
          fullPage={false}
          table={
            <Table
              headers={headers}
              data={data}
              grid={grid}
              components={monthlyTableComponents({ handleAction })}
            />
          }
        />
      }
    </Card>
  );
};
